import AutoComplete from 'material-ui/AutoComplete';
import createComponent from './createComponent';

// taken from below links and tweaked a bit.
// https://github.com/erikras/redux-form-material-ui/blob/master/src/AutoComplete.js

const mapError = (
  { meta: { touched, error, warning } = {}, input, ...props },
  errorProp = 'errorText'
) =>
  touched && (error || warning)
    ? {
        ...props,
        ...input,
        [errorProp]: error || warning,
      }
    : { ...input, ...props };

export default createComponent(
  AutoComplete,
  ({
    input: { onChange, value },
    onNewRequest,
    onUpdateInput,
    dataSourceConfig,
    dataSource,
    ...props
  }) => {
    dataSourceConfig = dataSourceConfig || { text: 'text', value: 'value' };
    return {
      ...mapError(props),
      dataSourceConfig,
      dataSource,
      searchText:
        dataSourceConfig && dataSource
          ? (dataSource.find(item => item[dataSourceConfig.value] === value) || {})[
              dataSourceConfig.text
            ]
          : value,
      filter: AutoComplete.noFilter,
      onNewRequest: (value, index) => {
        onChange(
          typeof value === 'object' && dataSourceConfig ? value[dataSourceConfig.value] : value
        );
        if (onNewRequest) {
          onNewRequest(value, index);
        }
      },
      onUpdateInput: value => {
        onChange(value);
        if (onUpdateInput) {
          onUpdateInput(value);
        }
      },
      listStyle: { maxHeight: 300, overflow: 'auto' },
    };
  }
);
